import { InfoOutlineIcon } from '@chakra-ui/icons';
import {
  IconButton,
  type Placement,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  Portal,
  Stack,
} from '@chakra-ui/react';
import type { PropsWithChildren } from 'react';

import {
  emitMixpanelUserEvent,
  PopoverTrigger,
  UserTrackingEvents,
} from '@revelio/core';

export type PlotConfigObject = {
  iconBoxSize: number;
  popoverPlacement: Placement;
};

export interface PlotInfoCompProps extends PropsWithChildren {
  plotInfoConfig: PlotConfigObject | null;
  topLeft?: React.ReactNode;
  disableInfoPopup?: boolean;
}

export const PlotInfoComp = ({
  plotInfoConfig,
  topLeft,
  disableInfoPopup = false,
  children,
}: PlotInfoCompProps) => {
  return (
    <Stack spacing={0} direction="row" align="center" display="inline-flex">
      {children && !disableInfoPopup && (
        <Popover
          trigger="hover"
          placement={plotInfoConfig?.popoverPlacement}
          openDelay={500}
          onOpen={() => {
            emitMixpanelUserEvent(UserTrackingEvents.TOOLTIP_OPEN);
          }}
          variant="tooltip"
          isLazy
        >
          <PopoverTrigger>
            <IconButton
              opacity={0}
              _groupHover={{ opacity: 1 }}
              aria-label="plot info"
              data-testid="plot-info-icon"
              colorScheme="gray"
              variant="plotInfo"
              size="1.2"
              top="1px"
              icon={<InfoOutlineIcon boxSize={plotInfoConfig?.iconBoxSize} />}
              minWidth={4}
            />
          </PopoverTrigger>
          <Portal>
            <PopoverContent>
              <PopoverArrow />
              <PopoverBody data-testid="plot-info-body">{children}</PopoverBody>
            </PopoverContent>
          </Portal>
        </Popover>
      )}
      {topLeft}
    </Stack>
  );
};

export default PlotInfoComp;
